// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3qX5s","inner":"Footer_inner__14qYN","nextIcon":"Footer_nextIcon___xOWQ","innerLeft":"Footer_innerLeft__Op5bF"};